import { ILocation } from "./ListOfHoursSimple";

export const mockOpenHours: Record<string, ILocation> = {
  skiPass: {
    id: "ski-pass-1",
    name: "Wyciągi narciarskie",
    type: "ski_pass",
    openHours: [
      {
        status: "open",
        from: "2023-01-01T08:00:00",
        to: "2033-01-01T18:00:00",
        data: {
          MONDAY: { from: "09:00:00", to: "21:50:00" },
          TUESDAY: { from: "09:00:00", to: "21:50:00" },
          WEDNESDAY: { from: "09:00:00", to: "21:50:00" },
          THURSDAY: { from: "09:00:00", to: "21:50:00" },
          FRIDAY: { from: "09:00:00", to: "21:50:00" },
          SATURDAY: { from: "09:00:00", to: "21:50:00" },
          SUNDAY: { from: "09:00:00", to: "21:50:00" },
        },
      },
    ],
  },
  skiRental: {
    id: "ski-rental-1",
    name: "Wypożyczalnie sprzętu",
    type: "ski_rental",
    openHours: [
      {
        status: "open",
        from: "2023-01-01T07:30:00",
        to: "2033-01-01T22:00:00",
        data: {
          MONDAY: { from: "08:00:00", to: "20:00:00" },
          TUESDAY: { from: "08:00:00", to: "20:00:00" },
          WEDNESDAY: { from: "08:00:00", to: "20:00:00" },
          THURSDAY: { from: "08:00:00", to: "20:00:00" },
          FRIDAY: { from: "08:00:00", to: "20:00:00" },
          SATURDAY: { from: "08:00:00", to: "20:00:00" },
          SUNDAY: { from: "08:00:00", to: "20:00:00" },
        },
      },
    ],
  },
  skiSchool: {
    id: "ski-school-1",
    name: "Szkoły narciarskie",
    type: "ski_schools",
    openHours: [
      {
        status: "open",
        from: "2023-01-01T09:00:00",
        to: "2033-01-01T22:00:00",
        data: {
          MONDAY: { from: "09:00:00", to: "22:00:00" },
          TUESDAY: { from: "09:00:00", to: "22:00:00" },
          WEDNESDAY: { from: "09:00:00", to: "22:00:00" },
          THURSDAY: { from: "09:00:00", to: "22:00:00" },
          FRIDAY: { from: "09:00:00", to: "22:00:00" },
          SATURDAY: { from: "09:00:00", to: "22:00:00" },
          SUNDAY: { from: "09:00:00", to: "22:00:00" },
        },
      },
    ],
  },
  restaurant: {
    id: "restaurant-1",
    name: "Restauracje",
    type: "restaurant",
    openHours: [
      {
        status: "open",
        from: "2023-01-01T12:00:00",
        to: "2033-01-01T22:00:00",
        data: {
          MONDAY: { from: "10:00:00", to: "21:30:00" },
          TUESDAY: { from: "10:00:00", to: "21:30:00" },
          WEDNESDAY: { from: "10:00:00", to: "21:30:00" },
          THURSDAY: { from: "10:00:00", to: "21:30:00" },
          FRIDAY: { from: "10:00:00", to: "21:30:00" },
          SATURDAY: { from: "10:00:00", to: "21:30:00" },
          SUNDAY: { from: "10:00:00", to: "21:30:00" },
        },
      },
    ],
  },
};
